import { reatomAsync, withDataAtom } from "@reatom/async";
import { atom, Ctx } from "@reatom/framework";
import promiseLimit from "p-limit";
import {
  axiosErrorHandler,
  convertLinkToSpuIdJob,
  convertSpuIdToProductIdJob,
  filterLinks,
  toastHandler,
} from "src/util";

const limit = promiseLimit(4);

const progressAtom = atom(0, "progressAtom");
const jsonConvertedSpuIdAtom = atom((ctx) => {
  const data = ctx.spy(convertedSpuIdAtom);
  return JSON.stringify(data, null, 2);
}, "jsonConvertedSpuIdAtom");
const convertedSpuIdAtom = atom(new Array<number>(), "convertedSpuIdAtom");
const jsonConvertedProductIdAtom = atom((ctx) => {
  const data = ctx.spy(convertedProductIdAtom);
  return JSON.stringify(data, null, 2);
}, "jsonConvertedProductIdAtom");
const convertedProductIdAtom = atom(
  new Array<number>(),
  "convertedProductIdAtom",
);

const convertLinksToSpuIdsAsyncAction = reatomAsync(
  async (ctx: Ctx, initialData: string) => {
    progressAtom(ctx, 0);
    const recognizedLinks = filterLinks(initialData);

    let completedJobs = 0;

    const spuResults = await Promise.all(
      recognizedLinks.map(({ link, platform }) => {
        return limit(() =>
          convertLinkToSpuIdJob(link, platform)
            .then((spuId) => ({ spuId, platform }))
            .finally(() => {
              completedJobs++;
              progressAtom(
                ctx,
                Math.ceil((completedJobs / recognizedLinks.length) * 100),
              );
            }),
        );
      }),
    ).catch(axiosErrorHandler);

    if (!spuResults)
      return toastHandler.warning({
        title: "Ошибка",
        content: "Результат пустой",
        name: "convertSpuIdsWarning",
      });

    const validSpu = spuResults.filter((item) => !isNaN(item.spuId));
    convertedSpuIdAtom(
      ctx,
      validSpu.map((item) => item.spuId),
    );

    const productsIds = await Promise.all(
      validSpu.map(({ spuId, platform }) => {
        return limit(() =>
          convertSpuIdToProductIdJob(String(spuId), platform).finally(() => {
            completedJobs++;
            progressAtom(
              ctx,
              Math.ceil((completedJobs / validSpu.length) * 100),
            );
          }),
        );
      }),
    ).catch(axiosErrorHandler);

    if (!productsIds)
      return toastHandler.warning({
        title: "Ошибка",
        content: "Результат пустой",
        name: "convertSpuIdsWarning",
      });

    convertedProductIdAtom(
      ctx,
      productsIds.filter((item) => item && !isNaN(item)),
    );

    return toastHandler.success({
      title: "Успех",
      content: "Ссылки конвертированы успешно",
      name: "convertSpuIdsSuccess",
    });
  },
).pipe(withDataAtom());

export const jsonConverterSpuIdStore = {
  progressAtom,
  jsonConvertedSpuIdAtom,
  jsonConvertedProductIdAtom,
  convertLinksToSpuIdsAsyncAction,
  convertedSpuIdAtom,
  convertedProductIdAtom,
};
